import '../../polyfills';

document.addEventListener('DOMContentLoaded', () => {
    // zobrazit dalších x produktů (ajax tlačítko)
    const loadMoreProducts = document.getElementById('load-more-products');

    if (loadMoreProducts) {
        loadMoreProducts.addEventListener('click', (event) => {
            event.preventDefault();
            const el = event.target;
            el.classList.remove('btn--secondary');
            el.classList.add('btn--primary');
            el.querySelector('.spinner').classList.remove('d-none');

            // todo ajax volání a překreslení snippetu
        });
    }
});
